import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './routes/Routes'; // Import AppRoutes
import ErrorBoundary from './components/ErrorBoundary';
import SEOHead from './components/SEOHead'; // Import SEO component
import StructuredData from './components/StructuredData'; // Import Structured Data component
import { useLocation } from 'react-router-dom';

const App = () => {
    const location = useLocation();
    const isDashboard = location.pathname.startsWith('/dashboard');
    return (
        <ErrorBoundary>
            <div className="App d-flex flex-column min-vh-100">
                <SEOHead /> {/* Add SEO component for dynamic meta tags */}
                <StructuredData /> {/* Add Structured Data for schema markup */}
                <Header /> {/* Display the Header on all pages */}
                <main className="flex-grow-1 main-content-offset">
                    <ErrorBoundary>
                        <AppRoutes /> {/* Use AppRoutes for routing */}
                    </ErrorBoundary>
                </main>
                {!isDashboard && <Footer />}
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </ErrorBoundary>
    );
};

export default App;
